export default "__VITE_ASSET__3eb27b91__"